import { onReady } from "/Assets/js/common/utilities.js";
import AutoComplete from "/Assets/libs/Autocomplete/autocomplete.js";

export default class SiteSearch {

    constructor() {
        const siteSearchCntnr = document.querySelector(".site-search");
        this.siteSearchCntnr = siteSearchCntnr;

        const desktopSiteSearchCntnr = document.querySelector(".site-search-desktop");
        this.desktopSiteSearchCntnr = desktopSiteSearchCntnr;

        const mobileSiteSearchCntnr = document.querySelector(".site-search-mobile");
        this.mobileSiteSearchCntnr = mobileSiteSearchCntnr;
    }

    init() {
        onReady(() => {
            if (!this.siteSearchCntnr)
                return;

            this.bindEvents();
            this.initAutoComplete();
            this.initSearchType();
        });
    }

    initSearchType() {
        const dropdownItems = document.querySelectorAll(".site-search .search-types li");
        dropdownItems.forEach(item => {
            const link = item.querySelector("a");
            if (link) {
                link.addEventListener("click", (e) => this.handleDropdownChange(e.target));
            }
        });

        const mobileSearchTypeInput = document.querySelector(".site-search-mobile input.search");
        if (mobileSearchTypeInput) {
            mobileSearchTypeInput.addEventListener("click", () => {
                const mobileSearchTypeCntnr = document.querySelector(".site-search-mobile .search-types");
                if (mobileSearchTypeCntnr) {
                    mobileSearchTypeCntnr.classList.add("is-visible");
                }
            });
        }
    }

    handleDropdownChange(item) {
        // Get the value from data-value attribute or fall back to text content
        const value = item.dataset.value || item.textContent.trim();
        const text = item.textContent.trim();

        // Remove active class from all items in the same dropdown
        const searchTypes = item.closest(".search-types");
        searchTypes.querySelectorAll("li").forEach(li => li.classList.remove("active"));

        // Add active class to the selected item's parent li
        item.closest("li").classList.add("active");

        // Update the dropdown toggle button text and icon
        const btnGroup = item.closest("search");
        const toggleButton = btnGroup.querySelector(".dropdown-toggle");
        if (toggleButton) {
            toggleButton.innerHTML = `${text} <span class="svgsprite"><svg aria-hidden="true" focusable="false"><use xlink:href="/dist/spritemap.svg#chevron-down"></use></svg></span>`;
        }

        // Update the hidden input value
        const hiddenInput = btnGroup.querySelector('input[type="hidden"]');
        if (hiddenInput) {
            hiddenInput.value = value.toLowerCase();
        }
    }

    initAutoComplete() {
        const autocompleteInputs = document.querySelectorAll(".site-search [data-suggestive-search]");

        // Exit if no matching elements found
        if (!autocompleteInputs || autocompleteInputs.length === 0) {
            return;
        }

        // Loop through each element with data-suggestive-search
        autocompleteInputs.forEach(input => {
            const url = input.getAttribute("data-suggestive-search");
            if (!url) return;

            const closestForm = input.closest("form");

            // Initialize AutoComplete for each input with the URL
            new AutoComplete(input, {
                minCharacters: 3,
                url: url,
                appendTo: closestForm
            });
        });
    }

    bindEvents() {
        var self = this;

        // desktop search events
        const siteSearchOpenButton = document.querySelector(".site-search-open");
        if (siteSearchOpenButton) {
            self.siteSearchOpenButton = siteSearchOpenButton;

            // open search (old vs new nav detection)
            self.siteSearchOpenButton.addEventListener("click", () => {
                const oldNav = document.querySelector(".main-nav-bar");
                if (oldNav) {
                    // old nav logic
                    oldNav.classList.remove("is-visible");
                    if (self.desktopSiteSearchCntnr) {
                        self.desktopSiteSearchCntnr.classList.add("is-visible");
                    }
                } else {
                    // new nav logic
                    const newNav = document.querySelector(".navbar-collapse.main-nav");
                    if (newNav) {
                        newNav.classList.add("hide");
                    }
                    if (self.desktopSiteSearchCntnr) {
                        self.desktopSiteSearchCntnr.classList.add("is-visible");
                    }
                    self.siteSearchOpenButton.classList.add("hide");
                }
            });

            // close search
            self.desktopSiteSearchCntnr.addEventListener("click", (event) => {
                if (!event.target.closest(".search-input-desktop-close")) return;
                event.preventDefault();

                const oldNav = document.querySelector(".main-nav-bar");
                if (oldNav) {
                    // old nav logic
                    oldNav.classList.add("is-visible");
                    self.desktopSiteSearchCntnr.classList.remove("is-visible");
                } else {
                    // new nav logic
                    const newNav = document.querySelector(".navbar-collapse.main-nav");
                    if (newNav) {
                        newNav.classList.remove("hide");
                    }
                    self.desktopSiteSearchCntnr.classList.remove("is-visible");
                    self.siteSearchOpenButton.classList.remove("hide");
                }
            }, false);
        }

        const desktopSearchInput = self.desktopSiteSearchCntnr.querySelector("input.search");
        if (desktopSearchInput) {
            // clear search input
            self.desktopSiteSearchCntnr.addEventListener("click", (event) => {
                if (!event.target.closest(".form-control-clear")) return;
                event.preventDefault();
                desktopSearchInput.value = "";
                self.desktopSiteSearchCntnr.querySelector(".form-control-clear").classList.add("is-hidden");
            }, false);

            // show search input clear button
            desktopSearchInput.addEventListener("input", () => {
                self.desktopSiteSearchCntnr.querySelector(".form-control-clear").classList.remove("is-hidden");
            });
        }

        // mobile search events
        const mobileSearchInput = self.mobileSiteSearchCntnr.querySelector("input.search");
        if (mobileSearchInput) {
            // clear search input
            self.mobileSiteSearchCntnr.addEventListener("click", (event) => {
                // Accept clicks on the clear button itself, any child inside it, or on a parent that contains the clear button.
                let clearSearchEl = event.target.closest(".clear-search");
                if (!clearSearchEl && event.target.querySelector) {
                    clearSearchEl = event.target.querySelector(".clear-search");
                }

                if (!clearSearchEl) return;
                event.preventDefault();
                mobileSearchInput.value = "";
                const formControlClear = self.mobileSiteSearchCntnr.querySelector(".form-control-clear");
                if (formControlClear) {
                    formControlClear.classList.add("is-hidden");
                }
            }, false);

            // show search input clear button
            mobileSearchInput.addEventListener("input", () => {
                self.mobileSiteSearchCntnr.querySelector(".form-control-clear").classList.remove("is-hidden");
            });
        }
    }
}
